var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgModalIconRegister(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_26)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_26)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32C16 23.1634 23.1634 16 32 16H100C108.837 16 116 23.1634 116 32V100C116 108.837 108.837 116 100 116H32C23.1634 116 16 108.837 16 100V32Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0271 87.6523C65.2726 91.9264 77.2489 85.6972 82.7771 73.7389C88.3053 61.7807 85.292 48.6218 76.0466 44.3477C66.8012 40.0737 54.8248 46.3029 49.2966 58.2611C43.7684 70.2193 46.7817 83.3782 56.0271 87.6523ZM59.3118 55.2376C59.1088 55.8835 59.0495 56.5629 59.1377 57.232V74.7112C59.1377 76.2489 59.1377 78.612 61.692 79.2873C62.1394 79.4143 62.6011 79.4899 63.0673 79.5123C63.6336 79.5621 64.2044 79.4939 64.7404 79.3126C65.2763 79.1312 65.7647 78.8411 66.1717 78.462C66.6024 77.9363 66.9182 77.3335 67.1005 76.6892C67.2827 76.0449 67.3277 75.3723 67.2327 74.7112V66.4591C67.3113 63.646 67.5078 59.6325 71.4374 58.9574C72.1573 58.9189 72.8789 58.9189 73.5987 58.9574C74.6355 58.9765 75.6432 58.6291 76.428 57.9821C77.0327 57.3177 77.355 56.4614 77.3318 55.5816C77.3481 55.1012 77.2541 54.6233 77.0567 54.1812C76.8593 53.7391 76.5631 53.3435 76.1888 53.022C75.8147 52.7005 75.3713 52.4609 74.8901 52.3199C74.4088 52.1789 73.9009 52.14 73.4023 52.2058C72.2816 52.1856 71.1759 52.4535 70.2011 52.9814C69.2263 53.5094 68.4182 54.2779 67.8615 55.2065C67.4052 55.9219 67.0485 56.6911 66.8005 57.4945V56.9695C66.9038 56.1634 66.7624 55.3462 66.3932 54.6148C66.024 53.8833 65.4425 53.2685 64.7178 52.8434C64.2042 52.6054 63.638 52.4896 63.0673 52.5058C62.5629 52.4758 62.0574 52.5471 61.5836 52.7151C61.1098 52.8831 60.6782 53.144 60.3166 53.4811C59.8571 53.9933 59.5149 54.5916 59.3118 55.2376Z",
    fill: "#7C39B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_26",
    x: 0,
    y: 0,
    width: 132,
    height: 132,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.160156 0 0 0 0 0.211953 0 0 0 0 0.3125 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_26"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_26",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_26"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 132,
    height: 132,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModalIconRegister);
export default __webpack_public_path__ + "static/media/modal-icon-register.5b14818606f09404930aba79d6dd474d.svg";
export { ForwardRef as ReactComponent };